import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import theme from '@ow/ow-components/lib/theme';
import Button from '@ow/ow-components/lib/components/Button';
import lodashGet from 'lodash.get';
import { getBrandSeoPathFromLocation } from '../../utils/RouteUtils';
import { getFilterValueFromSearchState } from '../../utils/searchUtils';
import { setRefineFilterString, setSearchStateForIndex } from '../../store/search/searchActions';
import { SEARCH_CONTEXT_BRAND_INFO } from '../../../constants/searchConstants';

const CAT_PATHS_CATEGORY_FACET_ID = 'catPaths';

const StyledLink = styled(Link)`
  :not(:last-child) {
    margin-right: 10px;
  }
`;

const BrandHeroLinkButton = styled(Button)`
  font-family: ${theme.fonts.brand};
  border-radius: 43px;
  border: 1px solid ${theme.colors.primary};
  font-size: 16px;
  font-weight: normal;
  line-height: 1.1;
  margin-bottom: ${theme.space.half};

  :hover {
    background-color: ${theme.colors.primary};
    color: ${theme.colors.secondary};
  }
`;

const FeaturedBrandHeroLinks = props => {
  const clearFacetsAndRange = () => {
    const { setRefineFilterString, refinementList, setSearchStateForIndex, searchIndex } = props;
    setRefineFilterString(null);
    setSearchStateForIndex(
      {
        refinementList: refinementList[CAT_PATHS_CATEGORY_FACET_ID]
          ? { catPaths: refinementList[CAT_PATHS_CATEGORY_FACET_ID] }
          : {},
        range: {}
      },
      SEARCH_CONTEXT_BRAND_INFO,
      searchIndex
    );
  };
  return props.content && props.content.length ? (
    <>
      {props.content.map((link, index) => (
        <StyledLink
          to={`${lodashGet(link, 'url', '')}`}
          type={
            lodashGet(link, 'url', '').includes(props.brandSeoPath) ? 'router-link' : 'hyper-link'
          }
          key={`brand-hero-link-${index}`}
          data-ref={`brand-hero-link-${index}`}
          onClick={clearFacetsAndRange}
          onKeyPress={e => e.key === 'Enter' && clearFacetsAndRange()}
        >
          <BrandHeroLinkButton>{lodashGet(link, 'title', '')}</BrandHeroLinkButton>
        </StyledLink>
      ))}
    </>
  ) : null;
};

FeaturedBrandHeroLinks.propTypes = {
  content: PropTypes.array,
  brandSeoPath: PropTypes.string,
  setRefineFilterString: PropTypes.func,
  setSearchStateForIndex: PropTypes.func,
  refinementList: PropTypes.object,
  searchIndex: PropTypes.string,
  navigateToTileLink: PropTypes.func
};

FeaturedBrandHeroLinks.defaultProps = {
  content: [],
  refinementList: {},
  setRefineFilterString: () => {},
  setSearchStateForIndex: () => {},
  navigateToTileLink: () => {}
};

const mapStateToProps = ({ brandInfo, search, searchConfig }) => {
  const brandSeoPathFromLocation =
    typeof window !== 'undefined'
      ? lodashGet(
          getBrandSeoPathFromLocation(lodashGet(window, 'location.pathname')),
          'seoPath',
          ''
        )
      : '';
  const { searchIndex } = searchConfig;
  return {
    brandSeoPath: lodashGet(brandInfo, `brand[${brandSeoPathFromLocation}].seoPath`, ''),
    refinementList: getFilterValueFromSearchState(
      SEARCH_CONTEXT_BRAND_INFO,
      searchIndex,
      search,
      'refinementList'
    ),
    searchIndex
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setRefineFilterString,
      setSearchStateForIndex
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedBrandHeroLinks);
export { FeaturedBrandHeroLinks };
